import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import en from "./locales/en.json";
import yo from "./locales/yo.json";
import ig from "./locales/ig.json";
import ha from "./locales/ha.json";
import sw from "./locales/sw.json";
import fil from "./locales/fil.json";
import pat from "./locales/pat.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";
import pt from "./locales/pt.json";
import de from "./locales/de.json";
import hi from "./locales/hi.json";

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "pt", label: "Português" },
  { code: "de", label: "Deutsch" },
  { code: "hi", label: "हिन्दी" },
  { code: "yo", label: "Yorùbá" },
  { code: "ig", label: "Igbo" },
  { code: "ha", label: "Hausa" },
  { code: "sw", label: "Kiswahili" },
  { code: "fil", label: "Filipino" },
  { code: "pat", label: "Patois" },
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en }, yo: { translation: yo }, ig: { translation: ig },
      ha: { translation: ha }, sw: { translation: sw }, fil: { translation: fil },
      pat: { translation: pat }, es: { translation: es }, fr: { translation: fr },
      pt: { translation: pt }, de: { translation: de }, hi: { translation: hi },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "yo", "ig", "ha", "sw", "fil", "pat", "es", "fr", "pt", "de", "hi"],
    nonExplicitSupportedLngs: true,
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "zuntria_lang",
      caches: [],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
